module.exports = __webpack_public_path__ + "media/images/partner-hand-a09f7578e17f5a4dc96f3a077c8c69ac.png";